import React from 'react';

// css
import {

    GridUbicacion,

    CampoUbicacion,

    LabelUbicacion,

    InputUbicacion

} from '../../../Css/StyledUbicacion.js';


const SelectorUbicacionManual = ({

    value,

    onChange,

    disabled = false,

    prefijo = 'ubicacion'

}) => {


    /*
    ========================================
    PROVINCIA / REGIÓN
    ========================================
    */

    const cambiarProvincia = (e) => {

        onChange?.({

            ...value,

            provincia:
                e.target.value,


            /*
            En una ubicación manual no existen
            IDs provenientes de Georef.
            */

            provincia_id:
                '',

            departamento:
                '',

            departamento_id:
                ''

        });
    };


    /*
    ========================================
    CIUDAD / LOCALIDAD
    ========================================
    */

    const cambiarLocalidad = (e) => {

        onChange?.({

            ...value,

            localidad:
                e.target.value,

            localidad_id:
                ''

        });
    };


    return (

        <GridUbicacion>


            <CampoUbicacion>

                <LabelUbicacion
                    htmlFor={`${prefijo}-region`}
                >
                    Provincia / estado / región
                </LabelUbicacion>


                <InputUbicacion

                    id={`${prefijo}-region`}

                    type="text"

                    value={
                        value.provincia || ''
                    }

                    disabled={
                        disabled
                    }

                    placeholder="Ej.: Montevideo"

                    onChange={
                        cambiarProvincia
                    }

                />

            </CampoUbicacion>


            <CampoUbicacion>

                <LabelUbicacion
                    htmlFor={`${prefijo}-localidad`}
                >
                    Ciudad / localidad
                </LabelUbicacion>


                <InputUbicacion

                    id={`${prefijo}-localidad`}

                    type="text"

                    value={
                        value.localidad || ''
                    }

                    disabled={
                        disabled
                    }

                    placeholder="Ej.: Montevideo"

                    onChange={
                        cambiarLocalidad
                    }

                />

            </CampoUbicacion>

        </GridUbicacion>
    );
};


export default SelectorUbicacionManual;